import { BuildingType } from "../config/buildings";
import { ProductType } from "../config/products";
import { TechSector } from "../config/tech-sector";
import { Language } from '../interfaces/language';

const catalogText = 'Catalogue Produits';
const buildingConsultText = 'KSBuilding Consult';
const landingpageText = 'Détails';
const planingText = 'En savoir plus';

const defaultWasteWaterProductLinks = (linkToPlaning?: string) => [
    {
        text: buildingConsultText,
        href: linkToPlaning ?? 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/ksbuilding-consult'
    },
    // {
    //     text: 'Zur Know-how-Broschüre',
    //     href: 'https://live-resources-e2e-sales.ksb.com/resource/blob/166112/fcac767dc8ef8b94919b12aed4fda6d9/dow-2drainage-planning-data.pdf'
    // }
]

const digitalDataLinks = [
    {
        text: landingpageText,
        href: 'https://www.ksb.com/fr-fr/applications/batiment/products/robinets-de-mesure-et-d-equilibrage',
    },
    {
        text: buildingConsultText,
        href: 'https://www.ksbuilding-consult.com/ApplRange.aspx'
    }
]

const defaultHeatingProductLinks = (linkToPlaning?: string) => [
    {
        text: buildingConsultText,
        href: linkToPlaning ?? 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/ksbuilding-consult'
    }
]

const heatingLandingpageLink = {
    text: landingpageText,
    href: 'https://www.ksb.com/fr-fr/applications/batiment/genie-climatique-et-thermique/circulateur-rotor-noye'
}

const defaultWaterProductLinks = (linkToPlaning?: string) => [
    {
        text: buildingConsultText,
        href: linkToPlaning ?? 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/ksbuilding-consult'
    }
]

export const frFr: Language = {
    locale: { language: 'fr', country: 'fr' },
    appTitle: 'KSBuilding City',
    appSubTitle: "Découvrez l'offre technique du bâtiment de KSB de manière interactive dans la KSBuilding City",
    backToCity: 'Revenir sur la KSBuilding City',
    back: 'Retour',
    city: {
        comingSoonBuilding: 'Evènements',
        comingSoonTechSector: 'Bientôt en ligne',
        newBuilding: 'Neu',
    },
    buildingDetails: {
        navigationTitle: "Choisissez un domaine d'application",
        navigationDescription: 'Cliquez sur un produit et découvrez-en les détails.',
        new: 'Nouveau',
    },
    newsletter: {
        title: 'Ne manquez pas nos actualités !',
        link: {
            text: 'S’inscrire à la Newsletter',
            href: 'https://go.ksb.com/fr-fr-subscription-page.html',
        },
    },
    contact: {
        text: 'Contact',
        href: 'https://www.ksb.com/fr-fr/contact',
    },
    buildings: {
        [BuildingType.HOUSE]: {
            name: 'Maison individuelle',
        },
        [BuildingType.APARTMENT]: {
            name: 'Bâtiment collectif',
        },
        [BuildingType.HOSPITAL]: {
            name: 'Hôpital',
        },
        [BuildingType.SCHOOL]: {
            name: 'Ecole',
        },
        [BuildingType.ADMINISTRATION]: {
            name: 'Bâtiment administratif',
        },
        [BuildingType.SKYSCRAPER]: {
            name: 'Skyscraper',
        },
        [BuildingType.INDUSTRY]: {
            name: 'Industrie',
        },
        [BuildingType.INDUSTRY_LAB]: {
            name: 'Laboratoire',
        },
        [BuildingType.INDUSTRY_PRODUCTION]: {
            name: 'Usine de production',
        },
        [BuildingType.INDUSTRY_TESTCENTER]: {
            name: "Station d'essai",
        },
        [BuildingType.INDUSTRY_SPRINKLER_CENTER]: {
            name: 'Sécurité Incendie',
        },
        [BuildingType.INDUSTRY_WATER]: {
            name: 'Approvisionnement central en eau',
        },
        [BuildingType.FACTORY]: {
            name: 'Usine de production',
        },
        [BuildingType.FACTORY_HEATING]: {
            name: 'Réseaux de Chaleur Urbains',
        },
        [BuildingType.FACTORY_SPRINKLER_CENTER]: {
            name: 'Sécurité Incendie',
        },
        [BuildingType.FACTORY_PROCESSES]: {
            name: 'Process industriels',
        },
        [BuildingType.FACTORY_PRODUCTION]: {
            name: 'Usine de production',
        },
        [BuildingType.HOTEL]: {
            name: 'Hôtel',
        },
        [BuildingType.INDUSTRY_HEATING]: {
            name: 'Usine de production',
        },
        [BuildingType.SKYSCRAPER_WATER_UPPER]: {
            name: 'Approvisionnement central en eau',
        },
        [BuildingType.KSB_CENTER]: {
            name: "L'équipe KSB",
            sectionTeam: 'L’équipe',
            sectionNews: 'Actualités',

            headline: '',
            teaser: {
                title: 'AmaDrainer 3',
                text: 'Die neue Generation der bewährten Schmutzwasser-Tauchmotorpumpen',
                footer: "Hier geht's zum neuen AmaDrainer in seiner gewohnten Umgebung",
            },
            teaserEtaline: {
                link: {
                    text: '« Tout savoir sur la nouvelle pompe en ligne Etaline Pro » ',
                    href: 'https://www.ksb.com/fr-fr/applications/new-era',
                },
            },
            linkList: [
                {
                    text: 'Webinaire',
                    href: 'https://go.ksb.com/fr-fr-subscription-page.html',
                },
                {
                    text: 'Outils de conception et aides à la planification',
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection',
                },
                {
                    text: 'Bibliothèque Digitale',
                    href: 'https://oxomi.com/p/2025286/switch?oxDeeplink=ewAiAHUAbgBpAHYAZQByAHMAYQBsAFMAZQBhAHIAYwBoAHwAMgAiADoAewAiAHYAaQBlAHcAIgA6ACIAaABvAG0AZQAiAH0AfQA%3D',
                },
                {
                    text: 'Catalogue Robinets',
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/trouver-les-pompes-et-les-robinets-avec-ksb-select/selectionner-une-vanne',
                },
                {
                    text: 'Catalogue Pompes',
                    href: 'https://www.ksb.com/fr-fr/produits/catalogue-produits?productType=PUMP',
                },
                {
                    text: 'Relations Presse',
                    href: 'https://www.ksb.com/fr-fr/societe/relations-media#click',
                },
                {
                    text: 'Carrières & Emploi',
                    href: 'https://www.ksb.com/fr-fr/carrieres',
                },
                {
                    text: 'Outils & Expertives',
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire',
                },
            ],
        },
        [BuildingType.KSB_TEAM]: {
            name: 'L’équipe',
            ctaText: 'En savoir plus',

            members: {
                beck: {
                    title: "L'ÉQUIPE QUI RÉSOUT LES PROBLÈMES LÀ OÙ D'AUTRES REFLECHISSENT LONGTEMPS.",
                    href: 'https://www.ksb.com/fr-fr/prestations-service',
                    content: (
                        <>
                            Proposer une aide rapide et complète en cas d'intervention sur les installations de pompage.
                            Connaître chaque groupe dans les moindres détails. Inspecter, entretenir et réparer dans les
                            règles de l'art.
                            <br />
                            Voilà pourquoi <strong>Ralph Beck</strong> :
                            <br />
                            <br />
                            <strong>Fou de technique du bâtiment.</strong>
                        </>
                    ),
                },
                bollmann: {
                    title: "LE PARTENAIRE QUI VOIT CLAIR LÀ OÙ D'AUTRES TÂTONNENT DANS L'OBSCURITÉ.",
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/savoir-faire/brochures-savoir-faire-ksb',
                    content: (
                        <>
                            Développer des solutions qui ne se contentent pas de satisfaire, mais qui enthousiasment.
                            Trouver la bonne pompe pour chaque projet. Et avoir une réponse à chaque question.
                            <br />
                            Voilà pourquoi <strong>Andreas Bollmann :</strong>
                            <br />
                            <br />
                            <strong>Fou de technique du bâtiment.</strong>
                        </>
                    ),
                },
                manss: {
                    title: "NOTRE SPÉCIALISTE QUI VIT DANS LE BIM, LÀ OÙ D'AUTRES RESTENT UNIDIMENSIONNELS.",
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/donnees-produits-numeriques',
                    content: (
                        <>
                            Soutenir les planificateurs de manière compétente. Avec des informations structurées sur les
                            produits et des visualisations 3D de la pompe ou de la vanne. Tout simplement via le portail
                            de données BIM (Building Information Modelling).
                            <br />
                            C'est pourquoi <strong>Daniel Manss</strong> :
                            <br />
                            <br />
                            <strong>Fou de technique du bâtiment.</strong>
                        </>
                    ),
                },
                schmidt: {
                    title: 'L\'ÉQUIPE DE PLANIFICATION QUI A DÉJÀ LE "DÉCLIC" ALORS QUE D\'AUTRES RÉFLÉCHISSENT ENCORE.',
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/ksbuilding-consult',
                    content: (
                        <>
                            Planifier des installations techniques de bâtiments en toute sécurité. Accompagner les
                            clients depuis la phase de conception jusqu'au calcul des coûts en passant par les appels
                            d'offres. Simple et intuitif avec KSBuilding Consult.
                            <br />
                            C'est pourquoi <strong>Sebastian Schmidt</strong> :
                            <br />
                            <br />
                            <strong>Fou de technique du bâtiment.</strong>
                        </>
                    ),
                },
                terock: {
                    title: "LE PARTENAIRE QUI PARTAGE SES CONNAISSANCES LÀ OÙ D'AUTRES HAUSSENT LES ÉPAULES.",
                    href: 'https://www.ksb.com/fr-fr/prestations-service/supremeserv-academy',
                    content: (
                        <>
                            Transmettre des conseils et astuces pratiques sur les produits KSB. Pour la planification,
                            l'installation, l'exploitation ou la maintenance. Pour que la pompe ne fasse pas que
                            ronronner, mais qu'elle débite aussi.
                            <br />
                            C'est pourquoi <strong>Bernhard Terock</strong> :
                            <br />
                            <br />
                            <strong>Fou de technique du bâtiment.</strong>
                        </>
                    ),
                },
            },
        },
    },
    sectors: {
        [TechSector.WATER]: {
            name: "Adduction d'eau / Surpression",
        },
        [TechSector.HEATING]: {
            name: 'Chauffage / Climatisation / Froid',
        },
        [TechSector.WASTE_WATER]: {
            name: 'Relevage / Assainissement',
        },
        [TechSector.FIRE_PROTECTION]: {
            name: 'Protection Incendie',
        },
    },
    products: {
        [ProductType.AMA_DRAINER_3]: {
            name: 'AmaDrainer 3',
            links: [
                {
                    text: planingText,
                    href: 'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Schmutzwasser-Tauchmotorpumpen.Schmutzwasserpumpen.',
                },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/groupe-motopompe-submersible/amadrainer-3/A07B',
                },
            ],
        },
        [ProductType.AMA_DRAINER_4_5]: {
            name: 'AmaDrainer 4/5',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Schmutzwasser-Tauchmotorpumpen.Schmutzwasserpumpen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/ama-drainer-4-5-ama-drainer-80-100/A76A',
                },
            ],
        },
        [ProductType.AMA_DRAINER_BOX_UNTERFLUR]: {
            name: 'AmaDrainer Box',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Hebeanlagen.Schmutzwasserhebeanlagen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/station-de-relevage-pour-eaux-usees/amadrainer-box-amadrainer-box-mini/A23A',
                },
            ],
        },
        [ProductType.AMA_DRAINER_BOX_UEBERFLUR]: {
            name: 'AmaDrainer Box Mini',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Hebeanlagen.Schmutzwasserhebeanlagen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/station-de-relevage-pour-eaux-usees/amadrainer-box-amadrainer-box-mini/A23A',
                },
            ],
        },
        [ProductType.AMAPORTER]: {
            name: 'Ama-Porter',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Schmutzwasser-Tauchmotorpumpen.Schmutzwasserpumpen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/ama-porter/A10A',
                },
            ],
        },
        [ProductType.AMAREX]: {
            name: 'Amarex',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Schmutzwasser-Tauchmotorpumpen.Tauchmotorpumpen (mit/ ohne Ex Schutz).',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/amarex/A31B',
                },
            ],
        },
        [ProductType.BOA_COMPACT_EKB]: {
            name: 'BOA-Compact EKB',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-compact-ekb/B02A',
                },
            ],
        },
        [ProductType.BOA_CONTROL_DPR]: {
            name: 'BOA-Control DPR',
            links: [
                ...digitalDataLinks,
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-control-dpr/B66A',
                },
            ],
        },
        [ProductType.BOA_CONTROL_IMS]: {
            name: 'BOA-Control IMS',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-control-boa-control-ims/B05B',
                },
            ],
        },
        [ProductType.BOA_CONTROL_PIC]: {
            name: 'BOA-Control PIC',
            links: [
                ...digitalDataLinks,
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-control-pic/B75A',
                },
            ],
        },
        [ProductType.BOA_CONTROL_SBV]: {
            name: 'BOA-Control SBV',
            links: [
                ...digitalDataLinks,
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-control-sbv/B79A',
                },
            ],
        },
        [ProductType.BOA_CVE]: {
            name: 'BOA-CVE',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-cve-h/B26A',
                },
            ],
        },
        [ProductType.BOA_CVE_IMS]: {
            name: 'BOA-CVE IMS',
            links: [
                ...defaultHeatingProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-soupape/boa-cve-c-cs-w-ims-ekb-ims-ekb/B04A',
                },
            ],
        },
        [ProductType.BOA_H]: {
            name: 'BOA-H',
            links: [],
        },
        [ProductType.BOA_RVK]: {
            name: 'BOA-RVK',
            links: [
                ...defaultHeatingProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/clapet-de-non-retour-a-soupape/boa-rvk/B11A',
                },
            ],
        },
        [ProductType.BOA_SYSTRONIC_EPIC]: {
            name: 'BOA Systronic ePic',
            links: [],
        },
        [ProductType.BOATRONIC_MS_420]: {
            name: 'BOATRONIC MS-420',
            links: [
                ...defaultHeatingProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/automatisation-de-robinetterie/boatronic-ms-boatronic-ms-420/B23B',
                },
            ],
        },
        [ProductType.BOATRONIC_MP]: {
            name: 'BOATRONIC MP',
            links: [
                {
                    text: landingpageText,
                    href: 'https://www.ksb.com/fr-fr/applications/batiment/products/robinets-de-mesure-et-d-equilibrage',
                },
            ],
        },
        [ProductType.BOAX_MAT]: {
            name: 'BOAXMAT',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/boax-s-sf/B12A',
                },
            ],
        },
        [ProductType.BOAX_S_SF]: {
            name: 'BOAX-S/SF',
            links: [
                {
                    text: buildingConsultText,
                    href: 'https://www.ksb.com/fr-fr/outils-et-savoir-faire/outils-de-selection/ksbuilding-consult',
                },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/boax-s-sf/B12A',
                },
            ],
        },
        [ProductType.CALIO]: {
            name: 'Calio Pro Plus',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Naßläufer Umwälzpumpen.Einzelpumpen.',
                ),
                { ...heatingLandingpageLink },
            ],
        },
        [ProductType.CALIO_S]: {
            name: 'Calio S Pro',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Naßläufer Umwälzpumpen.Einzelpumpen.',
                ),
                { ...heatingLandingpageLink },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/calio-s-pro/C90C',
                },
            ],
        },
        [ProductType.CALIO_THERM_S]: {
            name: 'CalioTherm S Pro',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Naßläufer Umwälzpumpen.Einzelpumpen.',
                ),
                { ...heatingLandingpageLink },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/caliotherm-s-pro/C91C',
                },
            ],
        },
        [ProductType.CALIO_Z]: {
            name: 'Calio Pro Plus Z',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Naßläufer Umwälzpumpen.Zwillingspumpe.',
                ),
                { ...heatingLandingpageLink },
            ],
        },
        [ProductType.CK_800]: {
            name: 'Station de relevage / CK 1000',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Pumpstationen (mit Ex Schutz).',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/station-de-relevage-pour-eaux-usees/station-de-relevage-ck-800-station-de-relevage-ck-1000/C05A',
                },
            ],
        },
        [ProductType.COMPACTA]: {
            name: 'Compacta',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Hebeanlagen.Fäkalienhebeanlagen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/filtra-n/F00A',
                },
            ],
        },
        [ProductType.DELTA_BASIC_COMPACT_MVP]: {
            name: 'DeltaCompact',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Druckerhöhungsanlagen.Mehrpumpen Druckerhöhungsanlagen.Drehzahlgeregelt.',
                ),
                {
                    text: planingText,
                    href: 'https://www.ksb.com/fr-fr/applications/batiment/products/surpresseurs',
                },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/groupes-de-surpression/deltacompact/D05B',
                },
            ],
        },
        [ProductType.DELTA_MACRO]: {
            name: 'DeltaCompact',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Druckerhöhungsanlagen.Mehrpumpen Druckerhöhungsanlagen.Drehzahlgeregelt.',
                ),
                {
                    text: planingText,
                    href: 'https://www.ksb.com/fr-fr/applications/batiment/products/surpresseurs',
                },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/groupes-de-surpression/deltacompact/D05B',
                },
            ],
        },
        [ProductType.ECOLINE_GT_40]: {
            name: 'Ecoline GT 40',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/vanne-a-guillotine/ecoline-gt-40/EF2A',
                },
            ],
        },
        [ProductType.ETALINE]: {
            name: 'Etaline',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Trockenläuferpumpen geregelt.Einzelpumpen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/etaline/E03B',
                },
            ],
        },
        [ProductType.ETALINE_SYT]: undefined,
        [ProductType.ETALINE_Z]: {
            name: 'Etaline Z',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Trockenläuferpumpen geregelt.Zwillingspumpe.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/etaline-z/E13B',
                },
            ],
        },
        [ProductType.ETANORM]: {
            name: 'Etanorm',
            links: [
                ...defaultHeatingProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Heizung/Klima/Kälte.Heizung.Trockenläuferpumpen geregelt.Einzelpumpen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/etanorm/E04B',
                },
            ],
        },
        [ProductType.ETANORM_FXV]: {
            name: 'Etanorm FXV',
            links: [
                {
                    text: landingpageText,
                    href: 'https://www.ksb.com/fr-fr/applications/batiment/lutte-anti-incendie/sprinkler',
                },
            ],
        },
        [ProductType.FILTRA]: {
            name: 'Filtra',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Schwimmbad.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/filtra-n/F00A',
                },
            ],
        },
        [ProductType.HPK]: {
            name: 'HPK',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/hpk/H02A',
                },
            ],
        },
        [ProductType.HYADUO_2_D_FL]: {
            //NICHT VERWENDET
            name: 'Hya-Duo 2 D FL',
            links: [
                //     {
                //         text: buildingConsultText,
                //         href: 'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Brandschutz.Hydrantenanlagen.Doppelpumpen-Feuerlöschanlagen.',
                //     },
                //     {
                //         text: catalogText,
                //         href: 'https://www.ksb.com/de-de/lc/produkte/system/druckerhoehungsanlage/hyaduo-2-d-fl/H44B',
                //     },
            ],
        },
        [ProductType.HYADUO_2_D_FL_COMPACT]: undefined,
        [ProductType.HYASOLO_2_D_FL_COMPACT]: undefined,
        [ProductType.HYA_RAIN_2_PLUS]: undefined,
        [ProductType.HYA_RAIN_N]: {
            name: 'Hya-Rain Eco',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Regenwassernutzung.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/station-de-valorisation-des-eaux-de-pluie/hyarain-2-hyarain-2-plus/H12B',
                },
            ],
        },
        [ProductType.IXO_PRO]: {
            name: 'Ixo Pro',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Brunnen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/groupe-motopompe-immerge/ixo-pro/I06A',
                },
            ],
        },
        [ProductType.KSB_DELTA_PRIMO_SVP]: {
            //auch DeltaMacro genannt
            name: 'DeltaPrimo SVP',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Druckerhöhungsanlagen.Mehrpumpen Druckerhöhungsanlagen.',
                ),
                {
                    text: planingText,
                    href: 'https://www.ksb.com/fr-fr/applications/batiment/products/surpresseurs',
                },
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/groupes-de-surpression/deltaprimo/D08A',
                },
            ],
        },
        [ProductType.KSB_SAFETY_BOOST]: {
            name: 'KSB Safety Boost ',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Trennstationen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/systeme/ksb-safety-boost/SA2A',
                },
            ],
        },
        [ProductType.LEVELCONTROL]: {
            name: 'LevelControl Basic 2',
            links: [
                ...defaultWasteWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/automatisation-de-pompe/levelcontrol-basic-2/L20A',
                },
            ],
        },
        [ProductType.MEGA_CPK]: {
            name: 'MegaCPK',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-a-installation-seche/megacpk/M48A',
                },
            ],
        },
        [ProductType.MINI_COMPACTA]: {
            name: 'MiniCompacta',
            links: [
                ...defaultWasteWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Entwässerung.Hebeanlagen.Fäkalienhebeanlagen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/mini-compacta/M09B',
                },
            ],
        },
        [ProductType.MOVITEC]: {
            name: 'Movitec',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/movitec/M12A',
                },
            ],
        },
        [ProductType.MOVITEC_VCI]: {
            name: 'Movitec VCI',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/pompe-submersible-a-arbre-vertical/movitec-vci/M94A',
                },
            ],
        },
        [ProductType.MULTI_ECO]: {
            name: 'MultiEco',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Hauswasserwerke.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/multi-eco/M17A',
                },
            ],
        },
        [ProductType.SERIE_2000]: {
            name: 'Serie 2000',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/clapet-de-non-retour-a-battant/serie-2000/S51A',
                },
            ],
        },
        [ProductType.SISTO_16]: {
            name: 'SISTO-16',
            links: [
                ...defaultHeatingProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-membrane/sisto-16/S40A',
                },
            ],
        },
        [ProductType.SISTO_16_TWA]: {
            //gibt es nicht in fr, deswegen überschrieben mit SISTO-16
            name: 'SISTO-16',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-membrane/sisto-16/S40A',
                },
            ],
        },
        [ProductType.SISTO_16_RGA]: {
            //gibt es nicht in fr, deswegen überschrieben mit SISTO-16
            name: 'SISTO-16',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/robinet/robinet-a-membrane/sisto-16/S40A',
                },
            ],
        },
        [ProductType.SISTO_RSK]: {
            name: 'Sisto-RSK',
            links: [
                ...defaultWaterProductLinks(),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/produkte/armatur/rueckschlagklappe/sisto-rsk/S65A',
                },
            ],
        },
        [ProductType.UPA]: {
            name: 'UPA',
            links: [
                ...defaultWaterProductLinks(
                    'https://www.ksbuilding-consult.com/pumpdeeplink.aspx?Startoption=S4P_ApplRangeSelection&AW__APPLRG=KSB.Gebäudetechnik.Wasserversorgung.Brunnen.',
                ),
                {
                    text: catalogText,
                    href: 'https://www.ksb.com/fr-fr/lc/products/pompe/groupe-motopompe-immerge/upa-c-150/U16A',
                },
            ],
        },
        [ProductType.UPA_VDS]: {
            name: 'UPA (VDS)',
            links: [],
        },
    },
};
